module.exports = __webpack_public_path__ + "static/media/sorting.84264d64.jpg";